<template>
  <div class="popup-wrapper">
    <div class="prize-wrapper">
      <div class="close" v-show="getTitleText" @click="close"></div>
       <div class="title" v-show="getTitleText">
         {{getTitleText}}
       </div>
       <st-card :btnMsg="btnMsg" :prize="prize" v-on="$listeners"></st-card>
    </div>
  </div>
</template>

<script>
import card from "./card";
export default {
  name: "index",
  props: {
    prize: {
      type: Object,
      required: true
    },
    btnMsg: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
    };
  },
  computed: {
    getTitleText(){
      let taskId = this.prize.taskId;
      return taskId === "1" ? this.$t('task.successCheckIn')
            :taskId === "2" ? this.$t('task.successWatched')
            :taskId === "3" ? this.$t('task.successShared')
            :''
    }
  },
  methods: {
    close(){
      this.$emit('close')
    }
  },
  mounted() {
    
  },
  components: {
    "st-card": card,
  },
};
</script>

<style lang="scss" rel="stylesheet/sass" scoped="scoped">
@import "@/assets/scss/reset.scss";
@import "@/assets/scss/function.scss";
.popup-wrapper{
  @include popup;
    display: flex;
    justify-content: center;
    align-items: center;
    .prize-wrapper{
        width: rem(500px); 
        height: rem(754px); 
        position: relative;
    }
    .close {
        position: absolute;
        right: rem(0px);
        top: rem(-130px);
        width: rem(42px);
        height: rem(43px);
        background-image: url("../../assets/images/popup/close.png");
        background-size: 100% 100%;
    }
    .title{
        position: absolute;
        left: 50%;
        top: rem(-80px);
        width: rem(504px);
        height: rem(101px);
        line-height: rem(101px);
        margin-left: rem(-252px);
        background-image: url("../../assets/images/popup/title_bg.webp");
        background-size: 100% 100%;
        font-size: rem(24px);
        text-align: center;
        color: #ffffff;
    }
}

</style>
